import moment from "moment";

export const baseCalendar = (startDate, endDate) => {

    let dates = [];
    let months = [];
    let years = [];
    let minDates = [];

    if (startDate && endDate) {
        var start = moment(startDate);
        var end = moment(endDate);
        var totalDays = end.diff(start, 'days');
        for (var i = 0; i <= totalDays; i++) {
            var refDate = moment(start);
            refDate.add(i, 'days');
            var date = refDate.format('YYYY-MM-DD');
            var year = parseInt(refDate.format('YYYY'));
            var month = parseInt(refDate.format('M'));
            var day = parseInt(refDate.format('D'));

            var dateInfo = { referenceDate: date, day: day, month: month, year: year };

            if (!years.includes(year)) {
                years.push(year);
            }
            if (!months.filter(x => x.month == month && x.year == year)[0]) {
                months.push(dateInfo);
            }

            var minDateExists = minDates.filter((x) => {
                var existingDate = moment(x.referenceDate);
                return (existingDate.diff(refDate) < 0 && x.year == year);
            })[0];


            if (!minDateExists) {
                minDates.push(dateInfo)
            }

            dates.push(dateInfo);
        }
    }
    return { dates: dates, months: months, years: years, startDates: minDates };
}

const academicPeriodFunctions = {
    baseCalendar
}

export default academicPeriodFunctions;